// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDisplayName = Component => {
  return Component.displayName || Component.name || 'Component';
};
//# sourceMappingURL=get-display-name.js.map